const actions = {
  GET_SINGLE_CUSTOMER_BEGIN: 'GET_SINGLE_CUSTOMER_BEGIN',
  GET_SINGLE_CUSTOMER_SUCCESS: 'GET_SINGLE_CUSTOMER_SUCCESS',
  GET_SINGLE_CUSTOMER_ERR: 'GET_SINGLE_CUSTOMER_ERR',

  GET_ALL_CUSTOMERS_BEGIN: 'GET_ALL_CUSTOMERS_BEGIN',
  GET_ALL_CUSTOMERS_SUCCESS: 'GET_ALL_CUSTOMERS_SUCCESS',
  GET_ALL_CUSTOMERS_ERR: 'GET_ALL_CUSTOMERS_ERR',

  SET_CUSTOMER_FORM_DATA: 'SET_CUSTOMER_FORM_DATA',

  getAllCustomersBegin: () => {
    return {
      type: actions.GET_ALL_CUSTOMERS_BEGIN,
    };
  },

  getAllCustomersSuccess: (data) => {
    return {
      type: actions.GET_ALL_CUSTOMERS_SUCCESS,
      data,
    };
  },

  getAllCustomersErr: (err) => {
    return {
      type: actions.GET_ALL_CUSTOMERS_SUCCESS,
      err,
    };
  },

  getSingleCustomerBegin: () => {
    return {
      type: actions.GET_SINGLE_CUSTOMER_BEGIN,
    };
  },

  getSingleCustomerSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_CUSTOMER_SUCCESS,
      data,
    };
  },

  getSingleCustomerErr: (err) => {
    return {
      type: actions.GET_SINGLE_CUSTOMER_ERR,
      err,
    };
  },

  setCustomerFormData: (data) => {
    return {
      type: actions.SET_CUSTOMER_FORM_DATA,
      data,
    };
  },
};

export default actions;
